export const TransportMode = {
    aerial: 'AERI',
    maritime : 'MARITIM',
    land: 'TERRESTRE'
}
